import { createFileRoute } from "@tanstack/react-router";
import React, { useState } from "react";
import { Link } from "@tanstack/react-router";
import { ArrowLeft, MailCheck } from "lucide-react";
import AuthLayout, { AuthHeading } from "@/components/layout/AuthLayout";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/forms";

export const Route = createFileRoute("/auth/forgot-password/")({
  component: ForgotPassword,
});

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setTimeout(() => {
      setSent(true);
      setLoading(false);
    }, 1500);
  };

  return (
    <AuthLayout>
      <Button variant="ghost" size="sm" asChild className="-ml-3 mb-6 text-muted-foreground">
        <Link to="/auth/login">
          <ArrowLeft />
          Back to sign in
        </Link>
      </Button>

      <AuthHeading
        title="Forgot password?"
        description="Enter your email and we'll send you a link to reset it."
      />

      {sent ? (
        <div className="space-y-4">
          <Alert variant="success">
            <MailCheck />
            <div>
              <AlertTitle>Check your inbox</AlertTitle>
              <AlertDescription>
                A reset link has been sent to {email}. Check your junk folder if it does not appear
                within 2 minutes.
              </AlertDescription>
            </div>
          </Alert>
          <Button asChild className="w-full" size="lg">
            <Link to="/auth/login">Return to sign in</Link>
          </Button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <Field label="Email address">
            <Input
              type="email"
              autoComplete="email"
              placeholder="name@organization.co.tz"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Field>
          <Button type="submit" className="w-full" size="lg" loading={loading}>
            {loading ? "Sending link…" : "Send reset link"}
          </Button>
        </form>
      )}

      <p className="mt-8 border-t border-border pt-6 text-center text-sm text-muted-foreground">
        Still need help?{" "}
        <a href="mailto:info@taskpart.co.tz" className="font-medium text-foreground hover:underline">
          Contact support
        </a>
      </p>
    </AuthLayout>
  );
}
